import type { Country } from "./Country.js";

export const countriesWithPplSupport = ["Czechia", "Slovakia"] satisfies `${Country}`[] as Country[];
